import { useCallback } from 'react';

import { OfferCalculatorContainer } from 'shared/containers/microfrontends/OfferCalculatorContainer';
import { MortgageOfferContainer } from 'shared/containers/MortgageOfferContainer';
import { MortgageWrapperIdName } from 'shared/constants/common';
import { ContainerInner } from 'shared/components/ContainerInner';
import * as styles from './styles.css';
import {
  setCalculatorValues,
  setCalculatorErrors,
  resetCalculatorErrors,
  resetCalculatorValues,
} from 'shared/redux/landingSlice';
import { useDispatch } from 'react-redux';
import { ICalculatorMcfValues, TCalculatorAnalytics, TCalculatorMcfErrorsItem } from 'shared/types/features';
import { useTracking } from '../../utils/tracking/useTracking';
import { InformationalSeoBlock } from '../InformationalSeoBlock/InformationalSeoBlock';
import { debounce } from '@cian/ui-kit/internal/utils';

export function MortgageWrapperContainer() {
  const dispatch = useDispatch();
  const { trackEditFormValues, trackClickOnMoreFilters } = useTracking();
  const debouncedCalculationTracking = debounce(
    (eventData: ICalculatorMcfValues) => trackEditFormValues(eventData),
    300,
  );

  const onSubmitCalculator = useCallback(
    async (e: CustomEvent<{ data: ICalculatorMcfValues }>) => {
      dispatch(
        setCalculatorValues({
          ...e.detail.data,
        }),
      );

      dispatch(resetCalculatorErrors());
      debouncedCalculationTracking(e.detail.data);
    },
    [dispatch],
  );

  const onCatchErrorCalculator = useCallback(
    (e: CustomEvent<{ data: TCalculatorMcfErrorsItem[] }>) => {
      dispatch(setCalculatorErrors(e.detail.data));
      dispatch(resetCalculatorValues());
    },
    [dispatch],
  );

  const onSendAnalyticsCalculatorEvent = useCallback((e: CustomEvent<{ data: TCalculatorAnalytics }>) => {
    const { eventName } = e.detail.data;

    if (eventName === 'onClickMoreFilters') {
      trackClickOnMoreFilters();
    }
  }, []);

  return (
    <div className={styles['root']}>
      <ContainerInner>
        <div id={MortgageWrapperIdName} className={styles['wrapper']}>
          <OfferCalculatorContainer
            onSubmitCalculatorEvent={onSubmitCalculator}
            onCatchErrorCalculatorEvent={onCatchErrorCalculator}
            onSendAnalyticsCalculatorEvent={onSendAnalyticsCalculatorEvent}
          />
          <MortgageOfferContainer />
        </div>
        <InformationalSeoBlock />
      </ContainerInner>
    </div>
  );
}
